import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69734a421beda80014f430ec/omnix_ai_platform/src/app/homepage/components/HomepageInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69734a421beda80014f430ec/omnix_ai_platform/src/components/common/Header.tsx");
